<div class="flex-column page-not-authorized">
    <h1> {{ 'info.page_not_authorized' | translate }} </h1>
</div>
